const Footer = () => {
    return (
        <footer className=" bg-black text-center  border-t-2 border-white">
            <div className="max-w-screen-lg mx-auto">
                <h1 className="px-2 font-display  text-sm md:text-lg text-gray-500 pt-2">
                    {" "}
                    &copy; Show Plex , Create By Roshan Kumar.{" "}
                </h1>
                <h1 className="px-2 font-display text-sm md:text-lg text-gray-500 pt-1 pb-1">
                    {" "}
                    All Rights Reserved. Terms and Agreements Privacy Policy
                </h1>
            </div>
        </footer>
    )
}

export default Footer
